<template>
  <div>
    <div class="title">
      <span>研究方向</span>
    </div>
    <div class="box-content ql-editor" v-html="teamDetail.researchDirection"></div>
  </div>
</template>

<script>
import {getTeamDetail} from '@/api/api'
import '@/dist/quill.core.css'
import '@/dist/quill.snow.css'
import '@/dist/quill.bubble.css'
export default {
  data () {
    return {
      teamDetail: {}
    }
  },
  created () {
    this.getTeamDetail()
  },
  methods: {
    getTeamDetail () {
      getTeamDetail().then(res => {
        if (res.code === 200) {
          this.teamDetail = res.data
        }
      })
    }
  }
}
</script>

<style scoped>
.title {
  letter-spacing: 1px;
  font-size: 28px;
  line-height:2em;
  color: #2f4f4f;
  border-bottom: 3px solid #2f4f4f;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/view/research.vue